@if (active) {
<div class="confirmation-wrapper" [class.--is-open]="active">
  <div role="dialog" class="confirmation" [class.--is-open]="ready">
    <div class="confirmation__header">
      <h2 class="confirmation__header__title">Atenção</h2>
    </div>
    <div class="confirmation__content">
      @for (message of confirmation.confirmation; track $index) {
      <p>{{ message }}</p>
      }
    </div>
    <div class="confirmation__actions">
      <button class="ds-button --is-default" (click)="onClickDeny()">cancelar</button>
      <button class="ds-button --is-secondary" (click)="onClickConfirm()">continuar</button>
    </div>
  </div>
  <div></div>
</div>
}
